import request from '@/umi-request';
import { AxiosPromise } from 'axios';

import { 
  FileBox, 
  FileBoxChange, 
  FileBoxDetails, 
  ResponseFileDeleted 
} from '@/interfaces/fileboxes';

import { PaginatedResponse } from '@/interfaces/response';

export async function getFileboxes(params: any = {}) {
  return request({
    url: `list-boxes/`,
    method: 'GET',
    params, 
  }) as AxiosPromise<PaginatedResponse<FileBox>>;
}

export async function getFilebox(id: number) {
  return request({
    url: `list-boxes/${id}/`,
    method: 'GET',
  }) as AxiosPromise<FileBox>;
}

export async function getFileboxFiles(id: number, params: any = {}) {
  return request({
    url: `list-boxes/${id}/box/`,
    method: 'GET',
    params,
  }) as AxiosPromise<PaginatedResponse<FileBoxDetails>>;
}

export async function createFilebox(data: any) {
  return request({
    url: `list-boxes/`,
    method: 'POST',
    data
  }) as AxiosPromise<FileBox>;
}

export async function sendFilebox(id: number, data: any) {
  return request({
    url: `list-boxes/${id}/exit_dpas/`,
    method: 'PUT',
    data,
  }) as AxiosPromise<FileBoxDetails>;
}

export async function addFiletoFilebox(data: any) {
  return request({
    url: `list-boxes/add_file/`,
    method: 'POST',
    data
  }) as AxiosPromise<FileBoxDetails>;
}

export async function receiveFilebox(id: number) {
  return request({
    url: `list-boxes/${id}/return_dpas/`,
    method: 'PUT',
  }) as AxiosPromise<FileBox>;
}

export async function deleteFilebox(id: number) {
  return request({
    url: `list-boxes/${id}/`,
    method: 'DELETE',
  }) as AxiosPromise<ResponseFileDeleted>;
}

export async function deleteFileInFilebox(id: number, file: number) {
  return request({
    url: `list-boxes/${id}/box/${file}/`,
    method: 'DELETE',
  }) as AxiosPromise<ResponseFileDeleted>; 
}

export async function deleteFilesInFilebox(id: number, data: any) {
  return request({
    url: `list-boxes/${id}/box/delete-files/`,
    method: 'DELETE',
    data,
  }) as AxiosPromise<ResponseFileDeleted>;
}

export async function getFileboxChanges(id: number) {
  return request({
    url: `list-boxes/${id}/change-box/`,
    method: 'GET',
  }) as AxiosPromise<FileBoxChange>;
}

export async function getFileboxPDF(id: number) {
  return request({
    url: `list-boxes/${id}/box/detailbox_pdf/`,
    method: 'GET',
    responseType: 'blob',
  }) as AxiosPromise<Blob>;
}

export async function getFileboxCSV(id: number) {
  return request({
    url: `list-boxes/${id}/box/detailbox_csv/`,
    method: 'GET',
    responseType: 'blob',
  }) as AxiosPromise<Blob>;
}
